/*
 * CUSTOMIZATIONS:
 * - aggiunto widget per il colore di sfondo customizzabile color_list
 */

import { defineMessages } from 'react-intl';

const messages = defineMessages({
  bg_color: {
    id: 'bg_color',
    defaultMessage: 'Colore di sfondo',
  },
  more: {
    id: 'Scopri di più',
    defaultMessage: 'Scopri di più',
  },
  LinkTitle: {
    id: 'Link al resto',
    defaultMessage: 'Link al resto',
  },
  LinkTo: {
    id: 'Link a',
    defaultMessage: 'Link a',
  },
});

const schemaHero = ({ intl }) => {
  return {
    title: 'Hero block',
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.more),
        fields: ['bgColor', 'linkTitle', 'linkHref'],
      },
    ],
    properties: {
      bgColor: {
        title: intl.formatMessage(messages.bg_color),
        widget: 'color_list',
        colors: [
          { name: 'primary', label: 'Primario' },
          { name: 'secondary', label: 'Secondario' },
          { name: 'white', label: 'Bianco' },
        ],
        defaultValue: 'primary',
      },
      linkTitle: {
        title: intl.formatMessage(messages.LinkTitle),
      },
      linkHref: {
        title: intl.formatMessage(messages.LinkTo),
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: ['Title', 'Description'],
        allowExternals: true,
      },
    },
  };
};
export default schemaHero;
